import { render } from "./ViewProduct.vue?vue&type=template&id=d07d8a5c&scoped=true"
import script from "./ViewProduct.vue?vue&type=script&lang=js"
export * from "./ViewProduct.vue?vue&type=script&lang=js"

import "./ViewProduct.vue?vue&type=style&index=0&id=d07d8a5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d07d8a5c"]])

export default __exports__